document.addEventListener('DOMContentLoaded', function () {
  initFaqs();
});

document.addEventListener('shopify:section:load', function () {
  initFaqs();
});

function initFaqs() {
  document.querySelectorAll('[data-faqs]').forEach(function (section) {
    if (section.dataset.initialized === 'true') {
      return;
    }

    section.dataset.initialized = 'true';

    const categoryButtons = section.querySelectorAll('[data-faq-category]');
    const faqGroups = section.querySelectorAll('[data-faq-group]');
    const faqTriggers = section.querySelectorAll('[data-faq-trigger]');

    // Close a FAQ
    function closeFaq(trigger) {
      const answer = trigger.nextElementSibling;

      trigger.setAttribute('aria-expanded', 'false');

      if (answer) {
        answer.classList.remove('is-open');
        answer.setAttribute('aria-hidden', 'true');
      }
    }

    // Category filtering
    categoryButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        const selectedCategory = button.dataset.faqCategory;

        categoryButtons.forEach(function (categoryButton) {
          categoryButton.classList.remove('is-active');
        });

        button.classList.add('is-active');

        faqGroups.forEach(function (group) {
          const isSelected = group.dataset.faqGroup === selectedCategory;

          group.classList.toggle('is-hidden', !isSelected);
        });

        // Close all FAQs when changing category
        faqTriggers.forEach(function (trigger) {
          closeFaq(trigger);
        });
      });
    });

    // FAQ accordion
    faqTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        const answer = trigger.nextElementSibling;

        if (!answer) {
          return;
        }

        const isOpen = trigger.getAttribute('aria-expanded') === 'true';

        // Close all FAQs first
        faqTriggers.forEach(function (otherTrigger) {
          closeFaq(otherTrigger);
        });

        // Open clicked FAQ only if it was previously closed
        if (!isOpen) {
          trigger.setAttribute('aria-expanded', 'true');
          answer.classList.add('is-open');
          answer.setAttribute('aria-hidden', 'false');
        }
      });
    });
  });
}

document.addEventListener('click', function (event) {
  const summary = event.target.closest(
    'details.product-accordion-row > summary, .product__accordion details > summary'
  );

  if (!summary) return;

  const current = summary.closest('details');
  const content = summary.nextElementSibling;

  if (!current || !content) return;

  event.preventDefault();

  const duration = 350;

  function animateAccordion(details, shouldOpen) {
    const trigger = details.querySelector('summary');
    const panel = trigger?.nextElementSibling;

    if (!trigger || !panel) return;

    panel.getAnimations().forEach(function (animation) {
      animation.cancel();
    });

    const startHeight = panel.getBoundingClientRect().height;

    if (shouldOpen) {
      details.open = true;
    }

    const endHeight = shouldOpen ? panel.scrollHeight : 0;

    panel.style.overflow = 'hidden';

    const animation = panel.animate(
      [
        { height: startHeight + 'px', opacity: shouldOpen ? 0 : 1 },
        { height: endHeight + 'px', opacity: shouldOpen ? 1 : 0 }
      ],
      {
        duration: duration,
        easing: 'ease',
        fill: 'forwards'
      }
    );

    animation.onfinish = function () {
      if (!shouldOpen) {
        details.open = false;
      }

      panel.style.overflow = '';
      animation.cancel();
    };
  }

  const shouldOpen = !current.open;

  document.querySelectorAll(
    'details.product-accordion-row, .product__accordion details'
  ).forEach(function (details) {
    if (details !== current && details.open) {
      animateAccordion(details, false);
    }
  });

  animateAccordion(current, shouldOpen);
});